<ax-agreement-history-action
  [proposal]="proposal"
  [agreement]="agreement"
  [agreementData]="agreementData"
  [historyData]="historyData"
  [isExternal]="isExternal"
></ax-agreement-history-action>

@if (agreement?.agreementData) {
  <ax-agreement-data
    class="overview"
    [myProfile]="myProfile"
    [proposal]="proposal"
    [language]="language"
    [agreementProperties]="(agreementProperties$ | async) || []"
    [showOutOfSync]="showOutOfSync"
    [agreementActive]="agreement?.active || false"
    [agreementConfirmed]="agreement?.agreementData?.confirmed || false"
    [agreementDocuments]="agreement?.agreementData?.documents || []"
    [isDeletedByOwner]="agreement?.deletedByOwner || false"
    (addProperty)="addProperty.next($event)"
    (editProperty)="editProperty.next($event)"
  ></ax-agreement-data>
}

@if (!isExternal) {
  <ax-agreement-status
    class="overview"
    [agreement]="agreement"
    [hasAgreementDataToDisplay]="(hasAgreementDataToDisplay$ | async) || false"
    [proposalHasVerification]="proposalHasVerification"
  ></ax-agreement-status>
  <ax-agreement-dates
    class="overview"
    [myProfile]="myProfile"
    [proposal]="proposal"
    [agreement]="agreement"
    [agreementData]="agreement?.agreementData"
  ></ax-agreement-dates>
  <ax-agreement-extra-info
    class="overview"
    [myProfile]="myProfile"
    [proposal]="proposal"
    [agreement]="agreement"
    [agreementData]="agreement?.agreementData"
    (didClickSendEmail)="didClickSendEmail.next($event)"
  ></ax-agreement-extra-info>
}

@if (!isExternal && (isOwner$ | async) && (hasMetadata$ | async)) {
  <ax-agreement-metadata class="overview" [agreement]="agreement"></ax-agreement-metadata>
}
